import {AxiosResponse} from "axios";
import {isNullOrUndefined} from "../../utils/utils";
import {toast} from "react-toastify";

export const useToastAPIHandler = () =>{
    const handleRequest = <T extends unknown>(promise: Promise<AxiosResponse<T>>, onSuccess:(response:any)=>void, onError?:(error:any)=>void, onEnd?:()=>void):void=>{
        promise.then((response:AxiosResponse<T>)=> {
            onSuccess(response);
        }).catch((error:any)=> {
            if(!isNullOrUndefined(error.request) && !isNullOrUndefined(error.request.response)){
                let errorResponse;
                try{
                    errorResponse = JSON.parse(error.request.response);
                }catch (e) {
                    console.log(e)
                }
                if(errorResponse && !isNullOrUndefined(errorResponse.validationErrors)){
                    Object.values<string>(errorResponse.validationErrors).forEach((errorMessage)=>{
                        toast.error(errorMessage, {position: toast.POSITION.TOP_CENTER});
                    })
                }else if(errorResponse && errorResponse.message){
                    toast.error(errorResponse.message, {position: toast.POSITION.TOP_CENTER});
                }else{
                    toast.error("Unknown Error", {position: toast.POSITION.TOP_CENTER});
                }
                if(!isNullOrUndefined(onError)){
                    // @ts-ignore
                    onError(errorResponse) ;
                }
            }else{
                toast.error("Unknown Error", {position: toast.POSITION.TOP_CENTER});
                console.log(error);
                if(!isNullOrUndefined(onError)){
                    // @ts-ignore
                    onError(error) ;
                }
            }
        }).finally(()=>{
        if(!isNullOrUndefined(onEnd)){
            // @ts-ignore
            onEnd()
        }
        });
    };

    return{
        handleRequest
    };
};
